import { render } from "./FormDraft.vue?vue&type=template&id=16627f31&scoped=true&ts=true"
import script from "./FormDraft.vue?vue&type=script&lang=ts"
export * from "./FormDraft.vue?vue&type=script&lang=ts"

import "./FormDraft.vue?vue&type=style&index=0&id=16627f31&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16627f31"]])

export default __exports__